module.exports = {"DOMESTIC":"DOMESTIC","LOCAL":"LOCAL","title":"Shipping & Returns"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingConstants.json
// module id = 1079
// module chunks = 4 14